import { Component, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Borrower } from 'app/models/dto/borrower.model';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { Assignment } from 'app/services/claim-lead/assignment.model';
import { ClaimRestrictions } from 'app/services/claim-lead/claim-lead.service';
import { InitiateCall } from 'app/store/call/call.actions';
import { ClaimAssignment, GetClaimRestrictions, ResetConflict } from 'app/store/claim-lead/claim-lead.actions';
import { ClaimLeadState } from 'app/store/claim-lead/claim-lead.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-claim-lead-bar-smart',
  templateUrl: './claim-lead-bar-smart.component.html',
  styleUrls: ['./claim-lead-bar-smart.component.scss']
})
export class ClaimLeadBarSmartComponent {

  @Select(ClaimLeadState.nextAssignmentExists) nextAssignmentExists$: Observable<boolean>;
  @Select(ClaimLeadState.claimRestrictions) claimRestrictions$: Observable<ClaimRestrictions>;
  @Select(ClaimLeadState.flagHighPriority) flagHighPriority$: Observable<boolean>;
  @Select(ClaimLeadState.loading) loading$: Observable<boolean>;
  @Select(ClaimLeadState.claimedLead) claimedLead$: Observable<Assignment>;
  @Select(ClaimLeadState.conflict) conflict$: Observable<boolean>;

  @Input() user: LenderUser;

  constructor(private store: Store) { }

  getNext() {
    this.store.dispatch(new ClaimAssignment());
  }

  ackNotAvailable() {
    this.store.dispatch(new ResetConflict());
  }

  refresh() {
    this.store.dispatch(new GetClaimRestrictions());
  }

  callNow(borrower: Borrower) {
    this.store.dispatch(new InitiateCall({ borrowerId: borrower.id, phone: '+' + borrower.phoneCountryCode + borrower.phone, borrower }));
  }
}
